import { useCallback } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { ConfirmationModal } from '../../../../Confirmation'

export function useFormikFieldChangeConfirmation(props) {
  const { changeConfirmationProps = EMPTY_OBJECT } = props

  const handleCancel = useCallback(() => props.setModal(null), [props.setModal])

  const handleSubmit = useCallback(
    value => () => {
      props.onSubmit(value)
      props.setModal(null)
    },
    [props.onSubmit, props.setModal]
  )

  const handleOpenChangeConfirmationModal = useCallback(
    value => {
      props.setModal(
        <ConfirmationModal
          {...changeConfirmationProps}
          onCancel={handleCancel}
          onSubmit={handleSubmit(value)}
        />
      )
    },
    [changeConfirmationProps]
  )

  return {
    handleOpenChangeConfirmationModal,
  }
}
